import { useEffect, useState } from "react";
import dollar from "../../assets/icons/dollar.svg";
import InputWithIcon from "../../components/InputWithIcon";

const AddScorecardData = ({
  error,
  propertyInfo,
  handleSubmit,
  handleClose,
  onSetFormData,
}) => {
  const [formState, setFormState] = useState(propertyInfo || {});

  // ✅ FIX: sync state when API response updates propertyInfo
  useEffect(() => {
    setFormState(propertyInfo);
  }, [propertyInfo]);

  const handleChange = (value, fieldName) => {
    const updatedDate = new Date();
    const numericValue = value.replace(/[^0-9]/g, "");

    const updatedForm = {
      ...formState,
      [fieldName]: numericValue,
      lastUpdateDate: updatedDate,
    };

    setFormState(updatedForm);
    onSetFormData(updatedForm);
  };

  return (
    <form
      className="contact-details light-bg-L h-screen overflow-y-auto h-[46rem]"
      onSubmit={handleSubmit}
    >
      <p className="dark-M body-L">SCORECARD GOALS</p>

      <div className="mt-6">
        {[
          { key: "dials_goal", label: "Dials" },
          { key: "conversations_goal", label: "Conversations" },
          { key: "talk_time_goal", label: "Talk Time" },
          { key: "new_8x8s_goal", label: "New 8x8s" },
          { key: "new_buyer_leads_goal", label: "New Buyer Leads" },
          {
            key: "initial_offers_w_different_buyers_goal",
            label: "Initial Offers w/ Different Buyers",
          },
          { key: "new_seller_leads_goal", label: "New Seller Leads" },
          { key: "new_bovs_goal", label: "New BOVs" },
          {
            key: "initial_offers_w_different_sellers_goal",
            label: "Initial Offers w/ Different Sellers",
          },
          { key: "exclusive_listings_goal", label: "Exclusive Listings" },
          { key: "executed_loi_goal", label: "Executed LOI" },
          { key: "gross_hopper_gains_goal", label: "Gross Hopper Gains" },
          {
            key: "gross_commission_closed_goal",
            label: "Gross Commission Closed",
          },
        ].map((item) => (
          <div key={item.key} className="mb-6 flex items-center gap-4">
            <label className="dark-H head-4 w-52">{item.label}</label>

            <InputWithIcon
              icon={
                [
                  "executed_loi_goal",
                  "gross_hopper_gains_goal",
                  "gross_commission_closed_goal",
                ].includes(item.key)
                  ? dollar
                  : null
              }
              className="body-N flex-2 w-[30%]"
              type="number"
              min="0"
              step="1"
              placeholder={`Enter ${item.label}`}
              value={formState[item.key] || ""}
              onChange={(e) => handleChange(e.target.value, item.key)}
              onWheel={(e) => e.target.blur()}
            />


          </div>
        ))}
      </div>

      <div className="mt-10">
        <button type="submit" className="save-button light-L head-5 green-bg-H">
          Save Scorecard Goal
        </button>

        <button type="button" onClick={handleClose} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddScorecardData;
